<!-- eslint-disable prettier/prettier -->
<mat-card appearance="outlined">
	<div class="m-5">
		<!-- <mat-card-header>
			<mat-card-title class="form-title">
				<h2>Datos personales</h2>
			</mat-card-title>
		</mat-card-header> -->

		<mat-card-content>
			<p class="form-subtitle">Completá los datos que faltan para continuar.</p>

			<form [formGroup]="personalInfoForm" class="grid grid-cols-1 gap-6 md:grid-cols-3">
				<!-- CUIL -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>CUIL</mat-label>
						<input matInput placeholder="20164974058" formControlName="cuil" />
					</mat-form-field>
					<mat-error>
						@if (personalInfoForm.get('cuil')?.touched) { {{
						personalInfoForm.get('cuil')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Nombre -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Nombre</mat-label>
						<input matInput placeholder="Leo" formControlName="nombre" />
					</mat-form-field>
					<mat-error>
						@if (personalInfoForm.get('nombre')?.touched) { {{
						personalInfoForm.get('nombre')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Apellido -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Apellido</mat-label>
						<input matInput placeholder="Blum" formControlName="apellido" />
					</mat-form-field>
					<mat-error>
						@if (personalInfoForm.get('apellido')?.touched) { {{
						personalInfoForm.get('apellido')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Fecha de nacimiento -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Fecha de nacimiento</mat-label>
						<input
							matInput
							[matDatepicker]="picker"
							placeholder="DD/MM/YYYY"
							formControlName="fechaDeNacimiento"
							[max]="maxDate"
						/>
						<mat-datepicker-toggle matIconSuffix [for]="picker" />
						<mat-datepicker #picker />
					</mat-form-field>
					<mat-error>
						@if (personalInfoForm.get('fechaDeNacimiento')?.touched) { {{
						personalInfoForm.get('fechaDeNacimiento')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Sexo -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Sexo</mat-label>
						<mat-select formControlName="sexo">
							@for (s of tiposSexo; track s.id) {
							<mat-option [value]="s.id">{{ s.description }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<mat-error>
						@if (personalInfoForm.get('sexo')?.touched) { {{
						personalInfoForm.get('sexo')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Nacionalidad -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Nacionalidad</mat-label>
						<mat-select formControlName="nacionalidad">
							@for (n of nacionalidades; track n.id) {
							<mat-option [value]="n.id">{{ n.description }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
			</form>
		</mat-card-content>
	</div>
</mat-card>
